export default function uniqueArray(array) {
	return [...new Set(array || [])];
}
